import { render, staticRenderFns } from "./EipTabs.vue?vue&type=template&id=0657caa9&"
import script from "./EipTabs.vue?vue&type=script&lang=js&"
export * from "./EipTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports